/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LatitudeLongitude
 */
export interface LatitudeLongitude {
  /**
   *
   * @type {number}
   * @memberof LatitudeLongitude
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof LatitudeLongitude
   */
  longitude?: number;
}

/**
 * Check if a given object implements the LatitudeLongitude interface.
 */
export function instanceOfLatitudeLongitude(
  value: object,
): value is LatitudeLongitude {
  return true;
}

export function LatitudeLongitudeFromJSON(json: any): LatitudeLongitude {
  return LatitudeLongitudeFromJSONTyped(json, false);
}

export function LatitudeLongitudeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LatitudeLongitude {
  if (json == null) {
    return json;
  }
  return {
    latitude: json["latitude"] == null ? undefined : json["latitude"],
    longitude: json["longitude"] == null ? undefined : json["longitude"],
  };
}

export function LatitudeLongitudeToJSON(json: any): LatitudeLongitude {
  return LatitudeLongitudeToJSONTyped(json, false);
}

export function LatitudeLongitudeToJSONTyped(
  value?: LatitudeLongitude | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    latitude: value["latitude"],
    longitude: value["longitude"],
  };
}
